import { PropsWithChildren } from 'react'
import { PageLoading } from '@maas-tools/auth-oidc'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'
import { RouterProvider, RouterProviderProps } from 'react-router-dom'
import AppError from 'containers/App/AppError'
import AppSidebar from 'containers/App/AppSidebar'
import AppTheme from 'containers/App/AppTheme'

const queryClient = new QueryClient()

const SideBar = ({ children, shouldRender }: PropsWithChildren<{ shouldRender?: boolean }>) => {
  if (shouldRender === false) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }
  return <AppSidebar paddingTop={0}>{children}</AppSidebar>
}
type TAppProps = {
  shouldRenderSideBar: boolean
} & Pick<RouterProviderProps, 'router'>

const App = ({ router, shouldRenderSideBar }: TAppProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppTheme>
        <SideBar shouldRender={shouldRenderSideBar}>
          <AppError>
            <SnackbarProvider maxSnack={3} preventDuplicate>
              <RouterProvider router={router} fallbackElement={<PageLoading />} />
            </SnackbarProvider>
          </AppError>
        </SideBar>
      </AppTheme>
    </QueryClientProvider>
  )
}

export default App
